import React from 'react';
import { Route, BrowserRouter as Router, Switch, Redirect } from 'react-router-dom'

import { Navbar } from './Navbar/Navbar';
import { ReDoc } from './ReDoc/ReDoc';
import { UserGuides } from './UserGuides/UserGuides';
import { ProductManuals } from './ProductManuals/ProductManuals';
import { NotFound } from './NotFound/NotFound';
import { getUrlPath } from '../utils';
import { GasMetersReDoc } from './GasMetersReDoc/GasMetersReDoc';

import './App.scss';

function App() {
    const apis = window.environment.apis;
    const showUserGuides = window.environment.showUserGuides;
    const showProductManuals = window.environment.showProductManuals;
    const showStormForAtlas = window.environment.showStormForAtlas;
    const showStormForDevices = window.environment.showStormForDevices;

    let defaultRoute = `/api-reference/${getUrlPath(apis[0].name)}`;

	if (!showStormForAtlas && showStormForDevices) {
        defaultRoute = "/devices";
    }

    return (
        <Router>
            <Navbar 
                apis={apis} 
                showUserGuides={showUserGuides} 
                showProductManuals={showProductManuals} 
                showStormForAtlas={showStormForAtlas}
                showStormForDevices={showStormForDevices}
            />
            <div className="app-container">
                <Switch>
                    <Redirect exact from="/" to={defaultRoute} />
                    <Redirect exact from="/api-reference" to={`/api-reference/${getUrlPath(apis[0].name)}`} />
                    {showStormForAtlas && (<Route exact path="/api-reference/:name" render={(props) => <ReDoc {...props} apis={apis} />} />)}
                    {showUserGuides && (<Route path="/user-guides" component={UserGuides} />)}
                    {showProductManuals && (<Route path="/product-manuals" component={ProductManuals} />)}
					{showStormForDevices && (<Route path="/devices" component={GasMetersReDoc} />)}
                    <Route component={NotFound} />
                </Switch>
            </div>
        </Router>
    );
}

export default App;